import React, { useEffect, useState, useMemo } from "react";
import { Image, Platform, ScrollView, TouchableOpacity, View } from "react-native";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconTokens, TextAlignTokens, TypographyTypeDLS, } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { addCommasToNumber } from "../utils";
import BoilerPlate from "../boilerPlate/BoilerPlate";
import CustomHeader from "../../customHeader/CustomHeader";
import { Icon } from "../../icon/Icon";
import { STATUS } from "./enums";
import { getDateMonthYearFromEpoch } from "../../stack/utils";
const PledgeHistory = ({ height, triggerAction, goBackAction, needHelpAction, pledgeHistoryData, goToDetailsScreenAction, fromInProgressProcess }) => {
    const [prevDate, setPrevDate] = useState('');
    const successColor = '#E7F4ED';
    const failedColor = '#FFE0E1';
    const inProgressColor = '#FEF4E6';
    const header = () => {
        return Platform.OS !== "web" ? (React.createElement(View, { style: { marginHorizontal: -16 } },
            React.createElement(CustomHeader, { title: 'Pledge history', triggerAction: triggerAction, goBackAction: goBackAction, needHelpAction: needHelpAction }))) : (React.createElement(React.Fragment, null,
            React.createElement(CustomHeader, { title: 'Pledge history', triggerAction: triggerAction, goBackAction: goBackAction, needHelpAction: needHelpAction })));
    };
    const renderStatusBox = (pledgeHistoryDetails, shouldShowTypography) => {
        const isRemovePledge = pledgeHistoryDetails?.totalValueOfUnpledgedAssets;
        const pledgeStatus = pledgeHistoryDetails?.status;
        const pledgedHistoryStatus = isRemovePledge && pledgeStatus === STATUS.SUCCESS ? "RTAs notified" : pledgeStatus === STATUS.SUCCESS ? "Completed" : pledgeStatus === STATUS.FAILED ? "Rejected" : "In progress";
        let pledgedHistoryBackgroundColor;
        if (pledgeStatus === STATUS.SUCCESS) {
            pledgedHistoryBackgroundColor = successColor;
        }
        else if (pledgeStatus === STATUS.FAILED) {
            pledgedHistoryBackgroundColor = failedColor;
        }
        else {
            pledgedHistoryBackgroundColor = inProgressColor;
        }
        const pledgedHistoryTextColor = pledgeStatus === STATUS.SUCCESS ? ColorTokens.Secondary_100 : pledgeStatus === STATUS.FAILED ? ColorTokens.System_Error : ColorTokens.System_Warning;
        return (React.createElement(View, { style: { paddingHorizontal: Platform.OS !== "web" ? 0 : 16, marginBottom: 16 } },
            React.createElement(View, { style: {
                    marginTop: shouldShowTypography ? 8 : 0,
                    borderColor: '#E4E7EC',
                    borderWidth: 1,
                    borderRadius: 8,
                    paddingTop: 12,
                    paddingLeft: 12,
                    paddingRight: 12,
                    paddingBottom: 10
                } },
                React.createElement(Typography, { label: isRemovePledge ? 'Remove pledge' : 'Pledge more', typeDLS: TypographyTypeDLS.B0S, color: ColorTokens.Grey_Night }),
                React.createElement(View, { style: {
                        marginTop: 8,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: isRemovePledge ? 'Portfolio value' : 'Additional credit limit', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal })),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: isRemovePledge ? `₹${addCommasToNumber(pledgeHistoryDetails?.totalValueOfUnpledgedAssets)}` : `₹${addCommasToNumber(pledgeHistoryDetails?.additionalCreditLimit)}`, typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: {
                        marginTop: 8,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    } },
                    React.createElement(Typography, { label: 'Status', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(View, { style: {
                            paddingHorizontal: 12,
                            paddingTop: 2,
                            paddingBottom: 2,
                            backgroundColor: pledgedHistoryBackgroundColor,
                            borderRadius: 4
                        } },
                        React.createElement(Typography, { label: pledgedHistoryStatus, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXS, lineHeight: 16, fontWeight: '500', color: pledgedHistoryTextColor }))),
                React.createElement(View, { style: { height: 1, width: '100%', backgroundColor: '#E4E7EC', marginTop: 8 } }),
                React.createElement(TouchableOpacity, { style: {
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        marginTop: 8,
                    }, onPress: () => {
                        triggerAction({
                            ...goToDetailsScreenAction,
                            payload: {
                                value: pledgeHistoryDetails,
                                fromInProgressProcess: fromInProgressProcess
                            }
                        });
                    } },
                    React.createElement(Typography, { label: "View details", typeDLS: TypographyTypeDLS.B2B, color: ColorTokens.Primary_100 }),
                    React.createElement(View, { style: { marginLeft: 8, marginBottom: 1 } },
                        React.createElement(Icon, { name: IconTokens.CHEVRON_BLUE_RIGHT }))))));
    };
    const emptyPledgeHistoryView = () => {
        return (React.createElement(View, { style: {
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
                alignSelf: 'center',
            } },
            React.createElement(Image, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/pledge_history_empty.png" }, style: { width: 200, height: 140, marginBottom: 24 } }),
            React.createElement(Typography, { label: "Looks like you haven't made\nany requests yet!", typeDLS: TypographyTypeDLS.B0M, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center })));
    };
    useEffect(() => {
        if (pledgeHistoryData.length > 0) {
            const date = new Date(pledgeHistoryData[0].createdOn);
            const formattedDate = date.toDateString();
            setPrevDate(formattedDate);
        }
    }, [pledgeHistoryData]);
    const pledgeHistoryListView = useMemo(() => {
        let prevDate = null;
        return Platform.OS !== "web" ? (React.createElement(View, { style: { marginHorizontal: 16, overflow: 'hidden' } }, pledgeHistoryData?.map((pledgeHistoryDetails, index) => {
            const date = new Date(pledgeHistoryDetails.createdOn);
            const formattedDate = date.toDateString();
            const dateToShow = getDateMonthYearFromEpoch(pledgeHistoryDetails?.createdOn);
            const shouldShowTypography = formattedDate !== prevDate;
            prevDate = formattedDate;
            return (React.createElement(View, null,
                shouldShowTypography ?
                    React.createElement(View, { style: { paddingLeft: Platform.OS !== "web" ? 0 : 16, marginTop: 16 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: `${dateToShow}`, color: ColorTokens.Grey_Charcoal })) : React.createElement(React.Fragment, null),
                renderStatusBox(pledgeHistoryDetails, shouldShowTypography)));
        }))) : (React.createElement(ScrollView, { contentContainerStyle: { paddingBottom: 40 } }, pledgeHistoryData.map((pledgeHistoryDetails, index) => {
            const date = new Date(pledgeHistoryDetails.createdOn);
            const formattedDate = date.toDateString();
            const dateToShow = getDateMonthYearFromEpoch(pledgeHistoryDetails?.createdOn);
            const shouldShowTypography = formattedDate !== prevDate;
            prevDate = formattedDate;
            return (React.createElement(View, null,
                shouldShowTypography &&
                    React.createElement(View, { style: { paddingLeft: 16, marginTop: 16 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: `${dateToShow}`, color: ColorTokens.Grey_Charcoal })),
                renderStatusBox(pledgeHistoryDetails, shouldShowTypography)));
        })));
    }, [pledgeHistoryData, prevDate]);
    return (React.createElement(BoilerPlate, { height: height, headerChild: React.createElement(React.Fragment, null, header()) }, pledgeHistoryData && pledgeHistoryData.length !== 0 ?
        Platform.OS !== "web" ?
            React.createElement(ScrollView, { contentContainerStyle: { paddingBottom: 40, marginHorizontal: -16 } }, pledgeHistoryListView)
            : React.createElement(React.Fragment, null, pledgeHistoryListView)
        : React.createElement(View, { style: {
                justifyContent: 'center',
                alignContent: 'center',
                alignSelf: 'center',
                alignItems: 'center',
                height: height - 58
            } }, emptyPledgeHistoryView())));
};
export default (PledgeHistory);
